import React from "react";

export const NotFound = () => {
  return <div>This page does not exist</div>;
};
